<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameSetting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameSetting.pageTitle'),
            href: '/game-settings'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-shadow-md">
            <h2
              class="ts-text-sm ts-font-semibold ts-p-2 ts-bg-gray-300 ts-rounded-b-none ts-rounded ts-text-blue-700 ts-uppercase"
            >
              {{ $t('gameSetting.main') }}
            </h2>
            <main-setup v-model="model" :validate="errors" />
          </div>
          <br />
          <h2
            class="ts-text-sm ts-font-semibold ts-p-2 ts-bg-gray-300 ts-rounded-b-none ts-rounded ts-text-blue-700 ts-uppercase"
          >
            {{ $t('gameSetting.detail') }}
          </h2>
          <detail-setup v-model="model" :validate="errors" ref="detail" />
          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <ts-button @click="$router.push({ name: 'game-setting' })">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                class="ml-2"
                color="primary"
                :waiting="waiting"
                @click.prevent="onUpdate"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import MainSetup from './components/main-setup'
import DetailSetup from './components/detail-setup'

export default {
  name: 'gameSettingEdit',
  components: {
    MainSetup,
    DetailSetup
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        game_type_id: 2,
        game_setting: '',
        description: '',
        minute_close_before_result: null,
        minute_allow_cancel_betting: null,
        num_day_allow_payout: null,
        inactive: false,
        game_logo: null,
        details: []
      },
      rows: {
        game_lot_id: 0,
        // game_setting_id: null,
        game_lot_name: null,
        unit_price: null,
        max_betting_amount: null,
        odds: null,
        channel_order: null,
        split_price: false,
        digit_taken: []
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('administrator/gameSetting', ['edit_data'])
  },
  methods: {
    ...mapActions('administrator/gameSetting', ['update']),
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.update({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'game-setting' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.game_type_id = this.edit_data.game_type_id
        this.model.game_setting = this.edit_data.game_setting
        this.model.description = this.edit_data.description
        this.model.minute_close_before_result = this.edit_data.minute_close_before_result
        this.model.minute_allow_cancel_betting = this.edit_data.minute_allow_cancel_betting
        this.model.num_day_allow_payout = this.edit_data.num_day_allow_payout
        this.model.inactive = !this.edit_data.inactive
        this.model.game_logo = this.edit_data.game_logo
        this.model.details = []
        this.createDetailEdit()
      }
    },
    createDetailEdit() {
      if (this.model.game_type_id == 1) {
        for (let i = 1; i <= 6; i++) {
          this.rows.channel_order = i
          this.model.details.push(Object.assign({}, this.rows))
        }
        this.edit_data.game_lots.map(el => {
          this.model.details
            .filter(d => d.channel_order == el.channel_order)
            .forEach(detail => {
              detail.game_lot_id = el.game_lot_id
              detail.game_setting_id = el.game_setting_id
              detail.game_lot_name = el.game_lot_name
              detail.unit_price = el.unit_price
              detail.max_betting_amount = el.max_betting_amount
              detail.odds = el.odds
              detail.channel_order = el.channel_order
              detail.split_price = el.split_price
              detail.digit_taken = this.convertDigitTakeArray(el.digit_taken)
            })
        })
      } else if (this.model.game_type_id == 2) {
        this.edit_data.game_lots.map(el => {
          this.model.details.push({
            game_lot_id: el.game_lot_id,
            game_setting_id: el.game_setting_id,
            game_lot_name: el.game_lot_name,
            unit_price: el.unit_price,
            max_betting_amount: el.max_betting_amount,
            odds: el.odds,
            channel_order: el.channel_order,
            split_price: el.split_price,
            digit_taken: this.convertDigitTakeArray(el.digit_taken)
          })
        })
      }
    },
    convertDigitTakeArray(item) {
      let result = []

      if (this.model.game_type_id == 2) {
        item
          .replace('{', '')
          .replace('}', '')
          .split(',')
          .forEach((el, index) => {
            if (parseInt(el)) {
              result.push(index)
            }
          })

        return result
      }

      return [parseInt(item.replace('{', '').replace('}', ''))]
    }
  },
  watch: {
    'model.game_type_id': function() {
      this.errors = new Errors()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameSetting/RESET_STATE')
    this.$store.commit('administrator/gameSetting/SET_EDIT_DATA', {})
    next()
  }
}
</script>
